import React from 'react';
import {
  AccordionCollpaseContent,
  QuarterHeaderCollapseTitle,
} from '@atoms/sidebar/sidebar.styles';
import Legend from '@molecules/pursuitLeader/components/legend';

const QuarterlyPastCollapsedSidebar = props => {
  const data = props?.data;
  const legendData = data['quarterlyCalculation'];
  const quarter = props?.quarter;

  return (
    <>
      <QuarterHeaderCollapseTitle>{quarter}</QuarterHeaderCollapseTitle>
      <AccordionCollpaseContent>
        <Legend quarterlyData={legendData} quarterText={quarter} quarterTitle={quarter} />
      </AccordionCollpaseContent>
    </>
  );
};

export default QuarterlyPastCollapsedSidebar;
